/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { find, findIndex, get, includes, isEmpty, map, size } from "lodash";
//

// import gsap from "gsap";

import { ICONS } from "../../constants/icons.constants";
import Icons from "../icons";
import { getFormattedTime } from "./musicPlayer.helpers";
import ThumbNail from "../thumbNail/ThumbNail";
import LoadingSkeleton from "../loadingSkeleton/LoadingSkeleton";
import ProgressBar from "../progressBar/ProgressBar";

import musicPlayerStore from "../../zustand/musicPlayer.store";
// import socketStore from "../../zustand/socket.store";

// import socket from "../../socket";
import { socketServices } from "../../services/socket.service";
import playlistStore from "../../zustand/playlist.store";
import SchedulesStore from "../../zustand/Schedule.store";
import { ROUTES } from "../../constants/routes.constants";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";

import { getToken } from "../../helpers/generel.helpers";
import { BASE_URL } from "../../axios";
import userStore from "../../zustand/user.store";
import { doTokenRefresh, fetchCustomerData } from "../../actions/user.actions";
import { shuffleArray } from "../../helpers/music.helpers";
import { playlistActions, scheduleActions, songActions } from "../../actions";
import ignoredSongStore from "../../zustand/ignoreSong.store";
import favoriteSongStore from "../../zustand/favoriteSong.store";

import styles from "./musicPlayer.module.scss";
import likedSongsStore from "../../zustand/likedSong.store";
import disLikedSongsStore from "../../zustand/dislikedSong.store";
import Like from "../reactionComponents/like/Like";
import Dislike from "../reactionComponents/dislike/Dislike";

const TIME_OUT = 12;
const PLAYER_SYNC_INTERVAL_MS = 5000; // Send player sync every 5 seconds

const MusicPlayer = () => {
  const {
    currentSongIndex,
    isLoading,
    setCurrentSongIndex,
    isPlaying,
    setIsPlaying,
    playList,
    setSongs,
    setPlayList,
    setAudioRef1,
    setAudioRef2,
    setCurrentAudioRefIndex,
    toggleIsShuffle,
    isShuffle,
    searchedSong,
    playSearchSong,
    beforeShuffleSongs,
  } = musicPlayerStore();

  const songs = playList?.songs || [];

  const { songs: favoriteSongs, setFavouriteToSong } = favoriteSongStore(
    (state) => ({
      songs: state.songs,
      setFavouriteToSong: state.setFavouriteToSong,
    })
  );
  const { isAuthenticated, setUser, user, userOffline } = userStore(
    (state) => ({
      isAuthenticated: state.isAuthenticated,
      setUser: state.setUser,
      user: state.user,
      userOffline: state.userOffline,
    })
  );
  const { schedulesDone, markScheduleDone, schedules } = SchedulesStore(
    (state) => ({
      schedulesDone: state.schedulesDone,
      markScheduleDone: state.markScheduleDone,
      schedules: state.schedules,
    })
  );
  const { playlists, setPlaylists } = playlistStore((state) => ({
    playlists: state.playlists,
    setPlaylists: state.setPlaylists,
  }));

  const { setSchedules } = SchedulesStore();
  const { songs: ignoredSongs, setIgnoreToSong } = ignoredSongStore(
    (state) => ({
      songs: state.songs,
      setIgnoreToSong: state.setIgnoreToSong,
    })
  );
  const { songs: likedSongs, setLikeToSong } = likedSongsStore((state) => ({
    songs: state.songs,
    setLikeToSong: state.setLikeToSong,
  }));
  const { songs: dislikedSongs, setDislikeToSong } = disLikedSongsStore(
    (state) => {
      return {
        songs: state.songs,
        setDislikeToSong: state.setDislikeToSong,
      };
    }
  );

  //
  const isShuffleRef = useRef(false);
  const workerRef = useRef(null);
  //
  const currentSongIdx = useRef(currentSongIndex);
  const songOffset = useRef(1);

  // for progress bar
  const progressBarRef = useRef(null);

  // for volume bar
  const volumeBarRef = useRef(null);

  // audio refs
  const audioRef1 = useRef(null);
  const audioRef2 = useRef(null);
  const currentAudioRefIndex = useRef(1);
  const getCurrentAudioRef = () =>
    currentAudioRefIndex.current === 1 ? audioRef1 : audioRef2;
  const getOtherAudioRef = () =>
    currentAudioRefIndex.current === 2 ? audioRef1 : audioRef2;
  const isFirstSongOfPlaylist = useRef(true);
  //
  const isPlayingRef = useRef(false);

  // refs for song time
  const currentTimeRef = useRef(null);
  const totalTimeRef = useRef(null);
  const isTimeChaneging = useRef(false);
  const isVolumeChanging = useRef(false);
  const isFadeOutStarted = useRef(false);
  const isRecentlyShuffled = useRef(false);
  const isRecentlyShuffled2 = useRef(false);
  const isShuffleFromInitialState = useRef(true);
  //
  const navigate = useNavigate();
  //
  const [isSongLoading, setIsSongLoading] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  //
  const songsRef = useRef(songs);
  const ignoredSongsRef = useRef(ignoredSongs);
  const playlistsRef = useRef(playlists);
  const playListRef = useRef(playList);
  const scheduleDoneRef = useRef(schedulesDone);
  const beforeShuffle = useRef(null);
  const searchedSongRef = useRef(searchedSong);
  const isPlaylistChanged = useRef(false);
  const socketRef = useRef(null);
  const tokenCounter = useRef(0);
  const scheduleCounter = useRef(0);
  const schedulesRef = useRef(schedules);
  const isViewAdded = useRef(false);
  const playerSyncIntervalRef = useRef(null);
  const userOfflineRef = useRef(userOffline);
  //
  // ? these are raw inputs only updated by the user
  const volume = useRef(1);
  // const progress = useRef(0);

  const handleLikeClick = async () => {
    const song = searchedSong ? searchedSong : songs[currentSongIndex];
    const { id } = song;

    setFavouriteToSong(id);

    const isSuccess = await songActions.addFavouriteToSong(id, userOffline);

    if (!isSuccess) {
      setFavouriteToSong(id);
      return;
    }
  };

  const handleIgnoreClick = async (e) => {
    e.stopPropagation();
    const song = searchedSong ? searchedSong : songs[currentSongIndex];
    const { id } = song;

    setIgnoreToSong(id);

    const isSuccess = await songActions.addReactionToSong(
      id,
      "IGNORE",
      userOffline
    );

    if (!isSuccess) {
      setIgnoreToSong(id);
    }
  };

  const handleSuffle = () => {
    isRecentlyShuffled.current = true;
    isRecentlyShuffled2.current = true;
    isShuffleFromInitialState.current = false;
    const shuffledSongs = shuffleArray([...songs], currentSongIdx.current);

    const indexes = map(shuffledSongs, (song) =>
      findIndex(songs, (s) => s.id === song.id)
    );

    const currentPlaylist = {
      ...playList,
      songs: shuffledSongs,
    };
    setPlayList(currentPlaylist, currentSongIdx.current);
    toggleIsShuffle(true);
    isShuffleRef.current = true;
    setIsPlaying(true);

    socketServices.sendEvent(
      {
        type: "SHUFFLE",
        shuffle: !isShuffle,
        songIndex: indexes,
      },
      userOffline
    );
    socketServices.sendEvent(
      {
        type: "TOGGLE_PLAY_STATE",
        status: true,
      },
      userOffline
    );

    //* prev logic
    // if (!isShuffle) {
    //   beforeShuffle.current = songs;
    //   const shuffledSongs = shuffleArray([...songs], currentSongIdx.current);
    //   const currentPlaylist = playList;
    //   playList.songs = shuffledSongs;
    //   setPlayList(currentPlaylist, currentSongIdx.current);
    //   toggleIsShuffle(true);
    //   isShuffleRef.current = true;
    // } else {
    //   const currentPlaylist = playList;
    //   playList.songs = beforeShuffle.current;
    //   setPlayList(currentPlaylist, currentSongIdx.current);
    //   toggleIsShuffle(false);
    //   isShuffleRef.current = false;
    // }
    // setIsPlaying(true);
  };

  const findNextValidSong = (offset) => {
    const songsSize = size(songsRef.current);
    let nextSongIndex = (currentSongIdx.current + offset) % songsSize;

    // Handle negative index case
    if (nextSongIndex < 0) {
      nextSongIndex = songsSize + nextSongIndex;
    }

    while (nextSongIndex !== currentSongIdx.current) {
      const song = songsRef.current[nextSongIndex];
      const songId = song?.id;

      if (!ignoredSongs[songId]) {
        break;
      }

      nextSongIndex = (nextSongIndex + offset) % songsSize;
      if (nextSongIndex < 0) {
        nextSongIndex = songsSize + nextSongIndex;
      }
    }

    return nextSongIndex;
  };

  const handleSongChagne = (offset) => () => {
    if (isSongLoading) return;

    let nextSongIndex = findNextValidSong(offset);

    setCurrentSongIndex(nextSongIndex);
  };

  const togglePlayButton = async () => {
    const playingState = isPlaying;
    if (!isPlaying && isFirstSongOfPlaylist.current)
      startSwitchFadeInEffect(volume.current);

    setIsPlaying(!isPlaying);

    try {
      if (playingState) {
        await socketServices.sendEvent(
          {
            type: "TOGGLE_PLAY_STATE",
            status: false,
          },
          userOffline
        );
      } else {
        const payload = {
          song_id: songs?.[currentSongIndex]?.id,
        };
        if (playList) {
          payload.playlist_id = playList.id;
        }
        await socketServices.sendEvent(
          {
            type: "TOGGLE_PLAY_STATE",
            status: true,
          },
          userOffline
        );
      }
    } catch (error) {}
  };

  const onSongListChange = () => {
    // const currentAudioRef = getCurrentAudioRef();
    setIsSongLoading(true);
    if (isPlayingRef.current) {
      getCurrentAudioRef()
        .current.play()
        .then(() => setIsSongLoading(false))
        .catch(() => setIsSongLoading(false));
      getCurrentAudioRef().current.volume = 0;
      startSwitchFadeInEffect(volume.current);
    } else {
      setIsSongLoading(false);
      isFirstSongOfPlaylist.current = true;
      getCurrentAudioRef().current.volume = 0;
    }
  };

  const startSwitchFadeInEffect = (endVal) => {
    isFirstSongOfPlaylist.current = false;
    if (workerRef.current) {
      workerRef.current.active.postMessage({
        type: "SWITCH_FADE_START",
        val: endVal,
        timeOut: TIME_OUT,
      });
      isVolumeChanging.current = false;
    }
  };

  const startFadeOnUpdate = (v) => {
    if (!isVolumeChanging.current) getCurrentAudioRef().current.volume = v;
  };

  const startFadeOnStart = () => {
    setIsSongLoading(true);
    currentAudioRefIndex.current = (currentAudioRefIndex.current % 2) + 1;
    // check if we have song from search then don;t change the index
    if (isPlaylistChanged.current) {
      isPlaylistChanged.current = false;
    } else if (!searchedSongRef.current) {
      const nextSongIndex = findNextValidSong(songOffset.current);
      currentSongIdx.current = nextSongIndex;
    } else {
      searchedSongRef.current = null;
      isPlaylistChanged.current = false;
    }

    songOffset.current = 1;

    if (isPlayingRef.current) {
      getCurrentAudioRef()
        .current.play()
        .then(() => {
          setIsSongLoading(false);
        })
        .catch((e) => {
          setIsSongLoading(false);
        });
    } else {
      setIsSongLoading(false);
      setIsPlaying(true);
    }
    isVolumeChanging.current = false;
  };

  const startFadeOnComplete = () => {
    isFadeOutStarted.current = false;
    getOtherAudioRef().current.src =
      songsRef.current?.[findNextValidSong(1) % size(songsRef.current)]?.url;
  };

  // ! replace this wiht serviec worker event
  const startFadeInEffect = (endVal) => {
    if (workerRef.current) {
      workerRef.current.active.postMessage({
        type: "START_FADE",
        val: endVal,
        timeOut: TIME_OUT,
      });
    }
  };

  const fadeOutOnUpdate = (v) => {
    if (!isVolumeChanging.current) getOtherAudioRef().current.volume = v;
  };

  // ! replace this wiht serviec worker event
  const startFadeOutEffect = (dif, startVal) => {
    if (workerRef.current) {
      getOtherAudioRef().current.src =
        songsRef.current?.[
          findNextValidSong(songOffset.current) % size(songsRef.current)
        ]?.url;
      workerRef.current.active.postMessage({
        type: "FADE_OUT",
        val: startVal,
        timeOut: TIME_OUT,
        diff: dif,
      });
    }
  };

  const counterRef = useRef(0);
  const nonUiLifeCycle = () => {
    // ? testing
    // nonUiLifeCycleCountRef.current -= 1;
    counterRef.current += 1;
    const currentAudioRef = getCurrentAudioRef();
    const dif =
      currentAudioRef.current?.duration - currentAudioRef.current?.currentTime;

    if (dif < TIME_OUT && !isFadeOutStarted.current) {
      isFadeOutStarted.current = true;
      startFadeOutEffect(dif, volume.current);
      startFadeInEffect(volume.current);
    }
    //
    tokenCounter.current += 500;
    scheduleCounter.current += 500;
    if (tokenCounter.current >= 8 * 60 * 1000) {
      tokenCounter.current = 0;
      // handleTokenRefresh();
    }
    if (scheduleCounter.current >= 1000) {
      scheduleCounter.current = 0;
      scheduleCycle();
    }

    workerRef.current.active.postMessage({
      type: "START_NON_UI_CYCLE",
    });
  };

  const uiLifeCycle = () => {
    const currentAudioRef = getCurrentAudioRef();

    if (!currentAudioRef.current) return;
    if (!currentAudioRef.current.src) return;

    currentTimeRef.current.innerHTML =
      getFormattedTime(currentAudioRef.current?.currentTime) || "00:00";
    totalTimeRef.current.innerHTML =
      getFormattedTime(currentAudioRef.current?.duration) || "00:00";

    if (!isTimeChaneging.current) {
      let progressValue =
        currentAudioRef.current.currentTime / currentAudioRef.current.duration;
      if (isNaN(progressValue)) progressValue = 0;
      progressBarRef.current.value = progressValue;
    }

    //* update song thumbnail UI
    if (currentSongIndex !== currentSongIdx.current) {
      setCurrentSongIndex(currentSongIdx.current);
    }
  };

  const scheduleCycle = async () => {
    for (let i = 0; i < size(schedulesRef.current); i++) {
      const currentSchedule = schedulesRef.current[i];

      if (!currentSchedule) continue;
      const slots = currentSchedule.slots;
      const playlist_id = currentSchedule.playlist_id;

      for (let j = 0; j < size(slots); j++) {
        const currentSlot = slots[j];
        if (!currentSlot) continue;

        const daysArray = currentSlot.days;
        const time = currentSlot.start_time; // this will return 00:00 format
        const id = currentSchedule.id;
        // today
        const dayToday = new Date().getDay(); // this will return 0 for sunday, 1 for monday and so on
        // get current time
        const timeToday = new Date().toLocaleTimeString("en-US", {
          hour12: false,
          hour: "numeric",
          minute: "numeric",
        }); // this will return 00:00 format

        if (daysArray.includes(dayToday) && timeToday === time) {
          const uniqeStoringId = `${id}-${dayToday}-${time}`;
          if (!scheduleDoneRef.current[uniqeStoringId]) {
            // play this playlist

            const playlistData = await playlistActions.fetchPlaylistById(
              playlist_id
            );

            const indexToPlay = findIndex(playlistData?.songs, (song) => {
              return !ignoredSongsRef.current[song.id];
            });

            // setSongs(playlistsRef.current[i].songs);
            setPlayList(playlistData, indexToPlay);
            setIsPlaying(true);
            navigate(ROUTES.HOME);
            //
            markScheduleDone(uniqeStoringId);
          }
          return;
        }
      }
    }

    workerRef.current.active.postMessage({
      type: "START_SCHEDULE_CYCLE",
    });
  };

  useEffect(() => {
    const id = setInterval(() => {
      uiLifeCycle();
    }, 500);
    return () => {
      clearInterval(id);
    };
  }, [currentSongIndex]);

  useEffect(() => {
    setAudioRef1(audioRef1.current);
    setAudioRef2(audioRef2.current);
    setCurrentAudioRefIndex(currentAudioRefIndex);
  }, []);

  useEffect(() => {
    // * initialize song
    songsRef.current = songs;
    const currentAudioRef = getCurrentAudioRef();

    if (isRecentlyShuffled.current) {
      isRecentlyShuffled.current = false;
      const otherAudioRef = getOtherAudioRef();
      const nextSongINdex = findNextValidSong(1) % size(songs);
      otherAudioRef.current.src = songs[nextSongINdex]?.url;
      return;
    }

    if (currentAudioRef.current?.src) {
      // * this line is responsible for playing select song from playlist
      // * playList dependecy is for this logic
      const playlistSongIndex = playList?.songIndex || 0;
      currentSongIdx.current = playlistSongIndex;

      isPlaylistChanged.current = true;
      const otherAudioRef = getOtherAudioRef();
      otherAudioRef.current.src = songs[playlistSongIndex]?.url;
      const dif =
        currentAudioRef.current?.duration -
        currentAudioRef.current?.currentTime;
      if (workerRef.current) {
        workerRef.current.active.postMessage({
          type: "FADE_OUT",
          val: volume.current,
          timeOut: TIME_OUT,
          diff: dif,
        });
      }
      startFadeInEffect(volume.current);
      return;
    }

    //* initializeing audio refs
    if (audioRef1.current && !isEmpty(songs)) {
      console.log(currentSongIdx.current, "currentSongIdx.current");
      getCurrentAudioRef().current.src = songs?.[currentSongIdx.current]?.url;
      getOtherAudioRef().current.src =
        songs?.[findNextValidSong(1) % size(songs)]?.url;
      // togglePlayButton();
      onSongListChange();
    }
  }, [songs, playList]);

  // * on song change from outside the music player
  useEffect(() => {
    isViewAdded.current = false;

    if (currentSongIndex !== currentSongIdx.current) {
      currentSongIdx.current = currentSongIndex;
      songOffset.current = currentSongIndex - currentSongIdx.current;
      const dif = Math.min(
        TIME_OUT,
        getCurrentAudioRef().current.duration -
          getCurrentAudioRef().current.currentTime
      );
      isFadeOutStarted.current = true;
      startFadeOutEffect(dif, volume.current);
      startFadeInEffect(volume.current);
    }
  }, [currentSongIndex]);

  const [addedTitle, setAddedTitle] = useState("");
  // ? service - worker
  useEffect(() => {
    const doEvents = (event) => {
      // console.log(event.data.type);
      if (event.data.type === "NON_UI_CYCLE") nonUiLifeCycle();
      else if (event.data.type === "START_FADE_UPDATE")
        startFadeOnUpdate(event.data.val);
      else if (event.data.type === "START_FADE_START") startFadeOnStart();
      else if (event.data.type === "START_FADE_COMPLETE") startFadeOnComplete();
      else if (event.data.type === "FADE_OUT_UPDATE")
        fadeOutOnUpdate(event.data.val);
    };
    //
    // caches.keys().then(function (names) {
    //   for (let name of names) caches.delete(name);
    //
    // serviceWorkerRegistration.register();

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((worker) => {
        workerRef.current = worker;
        worker.active.postMessage({
          type: "START_NON_UI_CYCLE",
        });
      });

      //
      navigator.serviceWorker.addEventListener("message", doEvents);
    }
    //
    // });

    return () => {
      navigator.serviceWorker.removeEventListener("message", doEvents);
      // unregister worker

      // navigator.serviceWorker.getRegistrations().then((registrations) => {
      //   for (let registration of registrations) {
      //     registration.unregister();
      //   }
      // });
    };
  }, []);

  useEffect(() => {
    const id = setTimeout(() => {
      setAddedTitle(".");
      // reduce olume by 1%
      getCurrentAudioRef().current.volume -= 0.01;
      setTimeout(() => {
        setAddedTitle("");
        // increase volume by 1%
        getCurrentAudioRef().current.volume += 0.01;
      }, 1000);
    }, 35000);

    return () => {
      clearTimeout(id);
    };
  }, []);

  // * play/pause
  useEffect(() => {
    isPlayingRef.current = isPlaying;
    const currentAudioRef = getCurrentAudioRef();
    if (!isPlaying) {
      audioRef1.current.pause();
      audioRef2.current.pause();
    } else {
      setIsSongLoading(true);
      // set the volume to max
      currentAudioRef.current.volume = volume.current;
      currentAudioRef.current
        .play()
        .then(() => {
          setIsSongLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsSongLoading(false);
        });
    }
  }, [isPlaying]);
  //

  const handleSongChaneFromSocket = async (data) => {
    //* new code
    const { playlist_id: socket_playlist_id, song_id: socket_song_id } = data;
    const current_playlist_id = playListRef.current?.id;

    if (isEmpty(socket_playlist_id) && !isEmpty(socket_song_id)) {
      const rawSong = await songActions.fetchSongById(
        socket_song_id,
        userOffline
      );

      playSearchSong(rawSong);
    } else if (socket_playlist_id === current_playlist_id) {
      const songIndex = findIndex(songsRef.current, { id: socket_song_id });
      if (songIndex !== -1) {
        setCurrentSongIndex(songIndex);
      }
    } else if (socket_playlist_id !== current_playlist_id) {
      const new_playlist = await playlistActions.fetchPlaylistById(
        socket_playlist_id
      );
      let songIndex = findIndex(new_playlist.songs, { id: socket_song_id });
      if (songIndex === -1) songIndex = 0;
      setPlayList(new_playlist, songIndex);
    }
  };

  const handleRefreshPlaylists = async () => {
    try {
      const customerData = await fetchCustomerData(user.id || "", userOffline);
      const { playlists } = customerData;
      setPlaylists(playlists);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleRefreshSchedule = async () => {
    try {
      const schedules = await scheduleActions.fetchSchedules(userOffline);

      const newSchedules = map(schedules, (schedule) => {
        const playlist = find(
          playlists,
          (playlist) =>
            get(playlist, "id", "") === get(schedule, "playlist_id", "")
        );

        return {
          ...schedule,
          name: get(playlist, "name", ""),
          thumbnail_img: get(playlist, "thumbnail_img", ""),
          // color: playlist.color,
        };
      });

      setSchedules(newSchedules);
    } catch (error) {
      console.log("error", error);
    }
  };

  //
  // useEffect(() => {
  //   if (isShuffleFromInitialState.current) return;

  //   if (isShuffle !== isShuffleRef.current) {
  //     const songsToUse = songsRef.current;
  //     const playlistToUse = playListRef.current;

  //     if (isShuffle) {
  //       beforeShuffle.current = songsToUse;
  //       const shuffledSongs = shuffleArray(
  //         [...songsToUse],
  //         currentSongIdx.current
  //       );
  //       const currentPlaylist = {
  //         ...playlistToUse,
  //         songs: shuffledSongs,
  //       };
  //       setPlayList(currentPlaylist, currentSongIdx.current);
  //       isShuffleRef.current = true;
  //     } else {
  //       const currentPlaylist = {
  //         ...playlistToUse,
  //         songs: beforeShuffle.current,
  //       };
  //       setPlayList(currentPlaylist, currentSongIdx.current);
  //       isShuffleRef.current = false;
  //     }
  //     setIsPlaying(true);
  //   }
  // }, [isShuffle]);

  const handleShuffleSongs = (data) => {
    const { shuffle, songIndex } = data;

    const newSongs = [];
    for (let i = 0; i < size(songIndex); i++) {
      const song = songsRef.current[songIndex[i]];
      newSongs.push(song);
    }

    const playlistToUse = playListRef.current;
    const currentPlaylist = {
      ...playlistToUse,
      songs: newSongs,
    };
    isShuffleRef.current = shuffle;
    isRecentlyShuffled.current = true;
    setPlayList(currentPlaylist, currentSongIdx.current);
    setIsPlaying(true);
    toggleIsShuffle(shuffle);
  };

  const connectSocket = () => {
    socketRef.current = io(BASE_URL, {
      reconnect: true,
      transports: ["websocket"],
      query: { token: getToken() }, // used for auth
    });
    socketRef.current.on("connect", () => {
      console.log("connected to socket");
      socketRef.current.on("message", (data) => {
        const { type } = data;
        console.log(data, "data from socket");
        if (type === "SHUFFLE") {
          // if (!!data.data.shuffle !== isShuffleRef.current)
          // isRecentlyShuffled.current = true;
          // isShuffleFromInitialState.current = false;
          // toggleIsShuffle(data.data.shuffle);
          handleShuffleSongs(data.data);
        } else if (type === "SONG_CHANGED") {
          handleSongChaneFromSocket(data.data);
        } else if (type === "VOLUME_CHANGED") {
          try {
            let volumeSocket = parseInt(data.data.volume);
            if (volumeSocket >= 0 && volumeSocket <= 100) {
              volumeSocket = `${volumeSocket / 100}`;
              getCurrentAudioRef().current.volume = volumeSocket;
              getOtherAudioRef().current.volume = 0;
              isVolumeChanging.current = true;
              volume.current = volumeSocket;
              volumeBarRef.current.value = volumeSocket;
            }
          } catch (err) {
            console.log(err);
          }
        } else if (type === "TOGGLE_PLAY_STATE") {
          // if (isPlayingRef.current)
          setIsPlaying(get(data, "data.status", false));
        } else if (type === "FAVORITE") {
          const { song_id } = data?.data || {};
          setFavouriteToSong(song_id);
        } else if (type === "REFRESH_PLAYLIST") {
          handleRefreshPlaylists();
        } else if (type === "REFRESH_SCHEDULE") {
          handleRefreshSchedule();
        } else if (type === "IGNORE") {
          // update ignore song
          const { song_id } = data?.data || {};
          setIgnoreToSong(song_id);
        } else if (type === "DISLIKE") {
          const { song_id } = data?.data || {};
          setDislikeToSong(song_id);
        } else if (type === "LIKE") {
          const { song_id } = data?.data || {};
          setLikeToSong(song_id);
        }
      });
    });
  };

  // const handleTokenRefresh = async () => {
  //   const id = await doTokenRefresh(userOffline);
  //   if (!id) return;
  //   setUser(id);
  //   // disconnectSocket();
  //   // connectSocket();
  // };

  const disconnectSocket = () => {
    socketRef.current.off("connect");
    socketRef.current.off("message");
    socketRef.current.disconnect();
  };

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     handleTokenRefresh();
  //   }, 10 * 60 * 1000);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      // stop music
      audioRef1.current.pause();
      audioRef2.current.pause();
    }
  }, [isAuthenticated]);

  // * socket
  useEffect(() => {
    if (userOffline) return;
    connectSocket();
    return disconnectSocket;
  }, [isAuthenticated]);

  // * send song change event to socket
  useEffect(() => {
    if (isRecentlyShuffled2.current) {
      isRecentlyShuffled2.current = false;
      return;
    }

    const payload = {};
    if (!isEmpty(songs)) {
      payload.song_id = songsRef.current?.[currentSongIndex]?.id;
    }
    if (playList) {
      payload.playlist_id = playList?.id;
    }
    if (searchedSong) {
      payload.song_id = searchedSong?.id;
      payload.song_name = searchedSong?.title;
      delete payload.playlist_id;
    }
    if (!isEmpty(payload)) {
      try {
        socketServices.sendEvent(
          {
            type: "SONG_CHANGED",
            song_id: payload.song_id,
            playlist_id: payload.playlist_id,
          },
          userOffline
        );
      } catch (error) {}
    }
  }, [currentSongIndex, songs, playList, searchedSong]);

  //* convert state to ref
  useEffect(() => {
    playlistsRef.current = playlists;
  }, [playlists]);

  useEffect(() => {
    scheduleDoneRef.current = schedulesDone;
  }, [schedulesDone]);

  useEffect(() => {
    playListRef.current = playList;
  }, [playList]);

  useEffect(() => {
    ignoredSongsRef.current = ignoredSongs;
  }, [ignoredSongs]);

  useEffect(() => {
    beforeShuffle.current = beforeShuffleSongs;
  }, [beforeShuffleSongs]);

  useEffect(() => {
    schedulesRef.current = schedules;
  }, [schedules]);

  useEffect(() => {
    userOfflineRef.current = userOffline;
    // If user goes offline, stop sync interval (no offline views)
    if (userOffline && playerSyncIntervalRef.current) {
      clearInterval(playerSyncIntervalRef.current);
      playerSyncIntervalRef.current = null;
    }
  }, [userOffline]);

  // handle Search Song Click
  useEffect(() => {
    if (!searchedSong) return;
    searchedSongRef.current = searchedSong;
    const currentAudioRef = getCurrentAudioRef();

    const otherAudioRef = getOtherAudioRef();
    otherAudioRef.current.src = searchedSong?.url;
    const dif =
      currentAudioRef.current?.duration - currentAudioRef.current?.currentTime;
    if (workerRef.current && isPlayingRef.current) {
      workerRef.current.active.postMessage({
        type: "FADE_OUT",
        val: volume.current,
        timeOut: TIME_OUT,
        diff: dif,
      });
    }
    startFadeInEffect(volume.current);
  }, [searchedSong]);

  //add a keyboard event listener detect when the user presses the space bar

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === "Space") {
        togglePlayButton();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isPlaying]);

  // Player sync effect - set up once on mount, uses refs for current values
  useEffect(() => {
    /**
     * Send player state to server via socket for view tracking.
     * Uses refs to access current values (avoids stale closures in intervals).
     * Uses short property names as per backend specification.
     * Only sends when user is online.
     */
    const sendPlayerSync = () => {

      // Don't send sync if user is offline - views not counted for offline playback
      if (userOfflineRef.current) return;
      if (!socketRef.current?.connected) return;


      // Use refs for current values to avoid stale closures
      const song =
        searchedSongRef.current || songsRef.current[currentSongIdx.current];
      if (!song) return;

      const audio = getCurrentAudioRef().current;
      if (!audio || !audio.src) return;

      const payload = {
        s: song.id, // song_id (string)
        p: audio.currentTime, // position in seconds (number)
        d: audio.duration || song.duration || 0, // total duration (number)
        i: !audio.paused, // isPlaying (boolean)
      };

      // Event name is "ps" (player sync)
      socketRef.current.emit("ps", payload);
    };

    /**
     * Start syncing player state when a song is loaded.
     * Sends sync every 5 seconds while a song is loaded.
     */
    const startPlayerSync = () => {
      // Clear any existing sync interval
      if (playerSyncIntervalRef.current) {
        clearInterval(playerSyncIntervalRef.current);
      }

      // Send initial sync immediately
      sendPlayerSync();

      // Start periodic sync every 5 seconds
      playerSyncIntervalRef.current = setInterval(
        sendPlayerSync,
        PLAYER_SYNC_INTERVAL_MS
      );
    };

    /**
     * Stop syncing when song ends or component unmounts
     */
    const stopPlayerSync = () => {
      if (playerSyncIntervalRef.current) {
        clearInterval(playerSyncIntervalRef.current);
        playerSyncIntervalRef.current = null;
      }
    };

    const handleLoadedData = (e) => {
      // Only start sync for the currently active audio ref
      if (e.target === getCurrentAudioRef().current) {
        startPlayerSync();
      }
    };

    const handlePlay = (e) => {
      // Send sync immediately on play for active audio
      if (e.target === getCurrentAudioRef().current) {
        sendPlayerSync();
      }
    };

    const handlePause = (e) => {
      // Send sync immediately on pause for active audio
      if (e.target === getCurrentAudioRef().current) {
        sendPlayerSync();
      }
    };

    const handleSeeked = (e) => {
      // Send sync on seek for active audio
      if (e.target === getCurrentAudioRef().current) {
        sendPlayerSync();
      }
    };

    const handleEnded = (e) => {
      // Stop sync when the active audio ends
      if (e.target === getCurrentAudioRef().current) {
        stopPlayerSync();
      }
    };

    // Add event listeners to both audio refs
    audioRef1.current.addEventListener("loadeddata", handleLoadedData);
    audioRef2.current.addEventListener("loadeddata", handleLoadedData);
    audioRef1.current.addEventListener("play", handlePlay);
    audioRef2.current.addEventListener("play", handlePlay);
    audioRef1.current.addEventListener("pause", handlePause);
    audioRef2.current.addEventListener("pause", handlePause);
    audioRef1.current.addEventListener("seeked", handleSeeked);
    audioRef2.current.addEventListener("seeked", handleSeeked);
    audioRef1.current.addEventListener("ended", handleEnded);
    audioRef2.current.addEventListener("ended", handleEnded);

    // If audio is already loaded (e.g. fast loads), start sync immediately
    const activeAudio = getCurrentAudioRef().current;
    if (activeAudio?.readyState >= 2 && activeAudio.src) {
      startPlayerSync();
    }

    return () => {
      stopPlayerSync();
      audioRef1.current?.removeEventListener("loadeddata", handleLoadedData);
      audioRef2.current?.removeEventListener("loadeddata", handleLoadedData);
      audioRef1.current?.removeEventListener("play", handlePlay);
      audioRef2.current?.removeEventListener("play", handlePlay);
      audioRef1.current?.removeEventListener("pause", handlePause);
      audioRef2.current?.removeEventListener("pause", handlePause);
      audioRef1.current?.removeEventListener("seeked", handleSeeked);
      audioRef2.current?.removeEventListener("seeked", handleSeeked);
      audioRef1.current?.removeEventListener("ended", handleEnded);
      audioRef2.current?.removeEventListener("ended", handleEnded);
    };
  }, []); // Empty deps - runs once on mount, uses refs for current values

  return (
    <>
      <audio
        ref={audioRef1}
        controls
        style={{ display: "none" }}
        crossOrigin="anonymous"
      />
      <audio
        ref={audioRef2}
        controls
        style={{ display: "none" }}
        crossOrigin="anonymous"
      />
      {isLoading ? (
        <div className={styles.container}>
          <LoadingSkeleton isSchedule />
        </div>
      ) : (
        <div
          className={styles.container}
          onClick={() => {}}
          style={{
            pointerEvents: isSongLoading || isEmpty(songs) ? "none" : "all",
          }}
        >
          <div className={styles.imageBox}>
            <ThumbNail
              name={
                searchedSong
                  ? searchedSong.title
                  : songs?.[currentSongIndex]?.title
              }
              color={
                searchedSong
                  ? searchedSong.color
                  : songs?.[currentSongIndex]?.color
              }
              imgSrc={
                searchedSong
                  ? searchedSong.thumbnail_img
                  : songs[currentSongIndex]?.thumbnail_img
              }
              hasImage={
                searchedSong
                  ? !isEmpty(searchedSong.thumbnail_img)
                  : !isEmpty(songs?.[currentSongIndex]?.thumbnail_img)
              }
            />
            <div className={styles.extraInfo}>
              <p className={styles.songName}>
                {searchedSong
                  ? searchedSong.title
                  : songs?.[currentSongIndex]?.title}
              </p>
              <p className={styles.writer}>
                {searchedSong
                  ? searchedSong.artist_name + addedTitle
                  : songs?.[currentSongIndex]?.artist_name + addedTitle}
              </p>
            </div>
            <div
              className={cx(styles.likedIcon, {
                [styles.activeLike]:
                  favoriteSongs?.[songs?.[currentSongIndex]?.id],
              })}
              onClick={handleLikeClick}
            >
              <Icons type={ICONS.LIKE_SONG_LIST} />
            </div>
            <div
              className={cx(styles.likedIcon, {
                [styles.activeIgnore]: get(
                  ignoredSongs,
                  songs?.[currentSongIndex]?.id || "",
                  false
                ),
              })}
              onClick={handleIgnoreClick}
            >
              <Icons type={ICONS.IGNORE_SONG} />
            </div>
          </div>

          <div className={styles.musicBox}>
            <div className={styles.iconBox}>
              <div
                style={{ transform: "scale(1.3)" }}
                className={styles.icon}
                onClick={handleSuffle}
              >
                <Icons
                  type={ICONS.SHUFFLE}
                  fill={isShuffle ? "#7442C7" : "#ffffff"}
                />
              </div>
              <div className={styles.icon} onClick={handleSongChagne(-1)}>
                <Icons type={ICONS.PREVIOUS} />
              </div>
              <div onClick={togglePlayButton} className={styles.icon}>
                {isPlaying ? (
                  <Icons type={ICONS.PLAY} />
                ) : (
                  <Icons type={ICONS.PAUSE} />
                )}
              </div>
              <div
                className={cx(styles.icon, styles.rotate)}
                onClick={handleSongChagne(1)}
              >
                <Icons type={ICONS.PREVIOUS} />
              </div>
              <div style={{ display: "none" }} className={styles.icon}>
                <Icons type={ICONS.REPEAT} />
              </div>
            </div>

            <div className={styles.barBox}>
              <p ref={currentTimeRef} className={styles.barTime}>
                {"00:00"}
              </p>
              <ProgressBar
                ref={progressBarRef}
                className={styles.musicBar}
                onChange={(e) => {
                  isTimeChaneging.current = true;
                }}
                onMouseUp={(e) => {
                  getCurrentAudioRef().current.currentTime =
                    getCurrentAudioRef().current.duration * e.target.value;
                  isTimeChaneging.current = false;
                  if (isFadeOutStarted.current) {
                    isVolumeChanging.current = true;
                    getCurrentAudioRef().current.volume =
                      volumeBarRef.current.value;
                    getOtherAudioRef().current.volume = 0;
                    isFadeOutStarted.current = false;
                  }
                }}
              />

              <p
                ref={totalTimeRef}
                className={styles.barTime}
                style={{ marginLeft: "0.8rem" }}
              >
                {"00:00"}
              </p>
            </div>
          </div>

          <div className={styles.volume}>
            <div className={cx(styles.columnLast)}>
              <Like row={songs?.[currentSongIndex]} />
              <div
                style={{
                  marginLeft: 20,
                }}
              >
                <Dislike row={songs?.[currentSongIndex]} />
              </div>
            </div>
            <div
              className={styles.VolumeIcon}
              onClick={() => {
                if (!isMuted) {
                  audioRef1.current.muted = true;
                  audioRef2.current.muted = true;
                } else {
                  audioRef1.current.muted = false;
                  audioRef2.current.muted = false;
                }
                setIsMuted((prev) => !prev);
              }}
            >
              {!isMuted ? (
                <Icons type={ICONS.VOLUME} />
              ) : (
                <Icons type={ICONS.MUTE} />
              )}
            </div>
            <div className={styles.volumeBar}>
              <ProgressBar
                className={styles.musicBar}
                ref={volumeBarRef}
                onChange={(e) => {
                  getCurrentAudioRef().current.volume = e.target.value;
                  getOtherAudioRef().current.volume = 0;
                  isVolumeChanging.current = true;
                  volume.current = e.target.value;
                }}
                onMouseUp={(e) => {
                  try {
                    socketServices.sendEvent(
                      {
                        type: "VOLUME_CHANGED",
                        volume: parseInt(e.target.value * 100),
                      },
                      userOffline
                    );
                  } catch (error) {}
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MusicPlayer;
